import wrappedAxios from "../axiosWrapper";
import { UserSettingsDataServer } from "./types";
import {
  getUserSettingsDataSql,
  postUserSettingsDataSql,
  postUserAcceptGuideSql,
} from "./urlParsers";

export const fetchUserSettings = () =>
  wrappedAxios<UserSettingsDataServer>({
    url: getUserSettingsDataSql(),
    method: "GET",
  });

export const postUserSettings = (data: UserSettingsDataServer) =>
  wrappedAxios<string>({
    url: postUserSettingsDataSql(),
    method: "PUT",
    data,
  });

export const postUserAcceptGuide = () =>
  wrappedAxios<string>({
    url: postUserAcceptGuideSql(),
    method: "PUT",
  });
